<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT设置速度报警"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="110">
      <FormItem prop="sources" label="速度来源">
        <Select v-model="setDriverCardParams.sources" style="width: 220px;">
          <Option v-for="item in sourcesOptions" :value="item.name" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="alarmType" label="报警类型">
        <Select v-model="setDriverCardParams.alarmType" style="width: 220px;">
          <Option v-for="item in alarmTypeOptions" :value="item.name" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="enabled" label="使能">
        <i-switch v-model="setDriverCardParams.enabled" size="large">
        </i-switch>
      </FormItem>
      <FormItem prop="limitingValue" label="门限值（km/h）">
        <Input v-model="setDriverCardParams.limitingValue" placeholder="门限值（km/h）" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="duration" label="持续时间（S）">
        <Input v-model="setDriverCardParams.duration" placeholder="持续时间（S）" style="width: 220px;">
        </Input>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">确认</Button>
    </Form>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  import MaintainOrderAddMaintainDeviceRecordModal
    from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

  export default {
    name: 'ztdriverspeedalarmmodal',
    components: {},
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        setDriverCardParams: {
          id: null,
          sources: '请选择',
          pulseFactor: 1000,
          alarmType: '请选择',
          enabled: false,
          limitingValue: 80,
          duration: '0',
        },
        //速度来源
        sourcesOptions: [
          {name: '请选择', value: 0},
          {name: 'GPS', value: 1},
          {name: '车辆', value: 2},
          {name: '混合', value: 3},
          {name: 'CAN', value: 4},
        ],
        //报警类型
        alarmTypeOptions: [
          {name: '请选择', value: 0},
          {name: '高速预警', value: 1},
          {name: '高速报警', value: 2},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange(val) {
        if (val) {
          this.setDriverCardParams.id = this._initValue
          this.setDriverCardParams.sources = '请选择'
          this.setDriverCardParams.pulseFactor = 1000
          this.setDriverCardParams.alarmType = '请选择'
          this.setDriverCardParams.enabled = false
          this.setDriverCardParams.limitingValue = 80
          this.setDriverCardParams.duration = '0'
        }
      },
      onCleanDriverCardParams() {
        this.setDriverCardParams.sources = '请选择'
        this.setDriverCardParams.pulseFactor = 1000
        this.setDriverCardParams.alarmType = '请选择'
        this.setDriverCardParams.enabled = false
        this.setDriverCardParams.limitingValue = 80
        this.setDriverCardParams.duration = '0'
      },
      onSendDriverCardParams() {


        if (this.setDriverCardParams.limitingValue == null || this.setDriverCardParams.limitingValue == '') {
          this.$Message.error('门限值不能为空')
          return
        }
        if (this.setDriverCardParams.limitingValue < 0 ) {
          this.$Message.error('门限值不能少于0')
          return
        }
        if (this.setDriverCardParams.duration == null || this.setDriverCardParams.duration == '') {
          this.$Message.error('持续时间不能为空')
          return
        }
        if (this.setDriverCardParams.duration < 0 ) {
          this.$Message.error('持续时间不能少于0')
          return
        }

        let content = '##_ZTTtsSet;速度报警设置;'

        if (this.setDriverCardParams.sources !=null && this.setDriverCardParams.sources != '' && this.setDriverCardParams.sources != '请选择'){
          content += '速度来源=' + this.setDriverCardParams.sources + ','
        }
          + '脉冲系数=' + this.setDriverCardParams.pulseFactor + ','
        if (this.setDriverCardParams.alarmType !=null && this.setDriverCardParams.alarmType != '' && this.setDriverCardParams.alarmType != '请选择'){
          content += '速度报警类型=' + this.setDriverCardParams.alarmType + ','
        }
        if (this.setDriverCardParams.enabled){
          content += '使能=开启,'
        } else {
          content += '使能=关闭,'
        }
        if (this.setDriverCardParams.limitingValue !=null && this.setDriverCardParams.limitingValue != ''){
          content += '门限值km/h='+this.setDriverCardParams.limitingValue + ','
        }
        if (this.setDriverCardParams.duration !=null && this.setDriverCardParams.duration != ''){
          content += '持续时间='+this.setDriverCardParams.duration + ','
        }
        content = content.substring(0,content.length-1)
        content += '$'
        console.log(content)
        let batchSendCmd = {cmd:null,urgent:false}
        batchSendCmd.cmd = content
        batchSendCmd.urgent = true
        // console.log(batchSendCmd)
        this.$emit('ZT_DriverSpeedAlarm',batchSendCmd)


        // store.dispatch('NetCommandServ_SendCommand', {
        //   params: {
        //     id: this._initValue,
        //     content: content,
        //     urgent: true
        //   }
        // }).then(() => {
        //   this.$Message.success('发送成功')
        // }).catch(err => {
        //   this.$Message.error(err)
        // })
      }
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get() {
          return this.terminalNumValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
